import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { Link } from 'react-router-dom'
import { api } from '../../services/api'
import { Card, Input, Spinner, Table, EmptyState, Badge } from '../../components/ui'
import { formatRut, insuranceLabel } from '../../utils/format'
import type { Patient } from '../../types/api'

export function PatientsPage() {
  const [search, setSearch] = useState('')

  const patients = useQuery({
    queryKey: ['patients', search],
    queryFn: async () => (await api.get<Patient[]>('/patients', { params: search ? { search } : {} })).data,
  })

  return (
    <div className="space-y-4">
      <h1 className="font-display text-2xl font-bold text-ink">Pacientes</h1>
      <Card>
        <Input
          placeholder="Buscar por nombre, RUT o teléfono…"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="max-w-md"
        />
      </Card>
      <Card>
        {patients.isLoading ? (
          <Spinner />
        ) : (patients.data?.length ?? 0) === 0 ? (
          <EmptyState message="Sin resultados. Los pacientes se crean desde el flujo de nueva cita." />
        ) : (
          <Table headers={['RUT', 'Nombre', 'Previsión', 'Teléfono', 'Empresa', '']}>
            {(patients.data ?? []).map((p) => (
              <tr key={p.id} className="hover:bg-gray-50">
                <td className="px-2 py-2 font-mono text-xs">{formatRut(p.rut)}</td>
                <td className="px-2 py-2 font-medium">
                  {p.firstName} {p.lastName}
                </td>
                <td className="px-2 py-2">
                  <Badge>{insuranceLabel(p)}</Badge>
                </td>
                <td className="px-2 py-2">{p.phone ?? '—'}</td>
                <td className="px-2 py-2 text-gray-500">{p.company?.businessName ?? '—'}</td>
                <td className="px-2 py-2 text-right">
                  <Link to={`/app/pacientes/${p.id}`} className="text-sm font-medium text-brand-700 hover:underline">
                    Ver ficha →
                  </Link>
                </td>
              </tr>
            ))}
          </Table>
        )}
      </Card>
    </div>
  )
}
